module.exports = __webpack_public_path__ + "img/gallery-4.92dddc9f.jpg";